package com.neurobs.ccabserver.administrator.controller

import com.neurobs.ccab.db.{AsrEngineData, ErrorClassData, ErrorTypeData, SettingData, StudyTypeData, TestData}
import com.neurobs.js.ccab.CCABServer
import com.neurobs.js.http
import com.neurobs.errors._

import scala.concurrent.{Future, Promise}
import scala.concurrent.ExecutionContext.Implicits.global

class RecordListCache[T](retrieve: (http.ServerObjectResponse[Seq[T]] => Unit) => http.RequestProcess) {
	private var cache: Option[Seq[T]] = None

	def clear(): Unit = { cache = None }

	def get: Future[Result[Seq[T]]] = cache match {
		case Some(data) => Future.successful(Right(data))
		case None =>
			val promise = Promise[Result[Seq[T]]]
			retrieve {
				case Left(error) => promise.success(Left(error.message))
				case Right(data) =>
					cache = Some(data)
					promise.success(Right(data))
			}
			promise.future
	}

	def getRecord(condition: T => Boolean): Future[Result[Option[T]]] = get map {
		case Left(error) => Left(error)
		case Right(list) => Right(list.find(condition))
	}

	def getRecordIgnoreErrors(condition: T => Boolean)(handler: Option[T] => Unit): Unit = getRecord(condition) map {
		case Left(error) =>
		case Right(data) => handler(data)
	}
}

class RecordCache {
	val studyTypes = new RecordListCache[StudyTypeData](CCABServer.getStudyTypes)

	val errorClasses = new RecordListCache[ErrorClassData](CCABServer.getErrorClasses)

	val errorTypes = new RecordListCache[ErrorTypeData](CCABServer.getErrorTypes)

	val settings = new RecordListCache[SettingData](CCABServer.getSettings)

	val asrEngines = new RecordListCache[AsrEngineData](CCABServer.getASREngines)

	val tests = new RecordListCache[TestData](CCABServer.getTests)
}
